import { addDays, format } from 'date-fns';

/** Return a Date at local NOON (prevents TZ/DST rollover to previous day). */
export const toLocalDateOnly = (d) => {
  const x = d instanceof Date ? d : new Date(d);
  return new Date(x.getFullYear(), x.getMonth(), x.getDate(), 12, 0, 0, 0);
};

/** Parse 'yyyy-MM-dd' into a local-noon Date (never new Date('yyyy-MM-dd')). */
export const fromYmdLocal = (s) => {
  const [y, m, d] = String(s).split('-').map(Number);
  return new Date(y, (m || 1) - 1, d || 1, 12, 0, 0, 0);
};

/** Format to 'yyyy-MM-dd' using local date parts (still normalizes to noon). */
export const ymdLocal = (d) => format(toLocalDateOnly(d), 'yyyy-MM-dd');

/** Add days in local date space, preserving noon anchor. */
export const addDaysLocal = (d, n) => addDays(toLocalDateOnly(d), n);
